// src/pages/PrivacyPage.tsx
import React from 'react';
import { Container, Typography } from '@mui/material';

const PrivacyPage: React.FC = () => (
    <Container maxWidth="md">
        <Typography variant="h4" component="h1" gutterBottom>Privacy Policy</Typography>
        <Typography variant="body1">
            Your privacy is important to us. It is LaiaTools' policy to respect your privacy regarding any information we may collect from you across our website.
            Detailed privacy policy content will be placed here.
        </Typography>
    </Container>
);

export default PrivacyPage;